/* eslint-disable @typescript-eslint/no-unused-expressions */
import {
  Box,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  GKButton,
  GKRadio,
  Grid2,
  PlusIcon,
  RadioGroup,
  Show,
  Typography,
} from "components";
import GKCheckbox from "components/GKCheckbox";
import { EquitybasketFormInterface } from "interfaces/EquityBasket";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useAppSelector } from "store/store";
import { AccountType } from "utils/common";
import AddBasketPartner from "./AddBasketPartner";

const SettingsTab = () => {
  const form = useFormContext<EquitybasketFormInterface>();

  const userInfo = useAppSelector((state) => state?.user?.userData);

  const [showPartnerModal, setShowPartnerModal] = useState(false);

  const partnerWatch = form.watch("publishPlatform");

  const publishPlatformData = [
    {
      title: "Publish basket on",
      name: "Micro-Website",
      value: "microWebsite",
      disabled: false,
      show: true,
    },
    {
      title: "Give Access to:",
      name: "Channel Partners",
      value: "channelPartners",
      disabled: false,
      show: ![AccountType.RA]?.includes(userInfo?.accountType),
    },
    // {
    //   name: "Reporting Manager- Admins",
    //   value: "reportingManagerAdmins",
    //   disabled: true,
    // },
    // { name: "Gridkey partners", value: "gridkeyPartners", disabled: true },
  ];

  return (
    <>
      <Grid2 container spacing={3}>
        <Grid2 size={12} display={"flex"} flexDirection={"column"}>
          <Controller
            name="publishPlatform"
            control={form.control}
            render={({ field }) => {
              return (
                <FormGroup>
                  {publishPlatformData
                    ?.filter((d) => d?.show)
                    ?.map((dataItem) => {
                      return (
                        <Box>
                          <Typography fontWeight={600}>
                            {dataItem.title}
                          </Typography>
                          <FormControlLabel
                            key={dataItem.value}
                            label={dataItem.name}
                            control={
                              <GKCheckbox
                                checked={field.value?.includes(dataItem.value)}
                                disabled={dataItem.disabled}
                                onChange={(event) => {
                                  const newValue = event.target.checked
                                    ? [...(field.value || []), dataItem.value]
                                    : field.value?.filter(
                                        (v: string) => v !== dataItem.value,
                                      );

                                  field.onChange(newValue);
                                }}
                                disableLeftPadding
                              />
                            }
                          />
                        </Box>
                      );
                    })}
                </FormGroup>
              );
            }}
          />
          {partnerWatch?.includes("channelPartners") && (
            <GKButton
              startIcon={<PlusIcon width={12} height={12} />}
              variant="outlined"
              color="dark"
              onClick={() => setShowPartnerModal(true)}
              sx={{ width: "fit-content", ml: 3 }}
            >
              Add Partner
            </GKButton>
          )}
        </Grid2>
        <Grid2 size={12}>
          <Typography fontWeight={600}>Subscription settings </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Typography color="#333">
            Enable allocation & rebalance on micro website:
          </Typography>
          <Box display={"flex"} flexDirection={"column"}>
            <Controller
              name="allowAllocation"
              control={form.control}
              render={({ field }) => {
                return (
                  <FormControlLabel
                    {...field}
                    label="Allocation"
                    control={
                      <GKCheckbox
                        disableLeftPadding
                        checked={field.value}
                        onChange={(event) => {
                          field.onChange(event.target.checked);
                        }}
                      />
                    }
                  />
                );
              }}
            />
            <Controller
              name="allowRebalance"
              control={form.control}
              render={({ field }) => {
                return (
                  <FormControlLabel
                    {...field}
                    label="Rebalance"
                    control={
                      <GKCheckbox
                        disableLeftPadding
                        checked={field.value}
                        onChange={(event) => {
                          field.onChange(event.target.checked);
                        }}
                      />
                    }
                  />
                );
              }}
            />
          </Box>
        </Grid2>

        <Grid2 size={12}>
          <Controller
            name="rebalanceReferenceWeightage"
            control={form.control}
            render={({ field }) => {
              return (
                <FormControl>
                  <FormLabel
                    style={{
                      color: "#333",
                    }}
                  >
                    Select reference weightage for allocation & rebalance:{" "}
                  </FormLabel>
                  <RadioGroup
                    {...field}
                    onChange={(event) => {
                      form.setValue(
                        "allocationReferenceWeightage",
                        JSON.parse(event.target.value),
                      );
                      field.onChange(JSON.parse(event.target.value));
                    }}
                  >
                    <FormControlLabel
                      value="true"
                      control={<GKRadio disableLeftPadding />}
                      label="Allocation weightage"
                    />
                    <FormControlLabel
                      value="false"
                      control={<GKRadio disableLeftPadding />}
                      label="Current weightage"
                    />
                  </RadioGroup>
                </FormControl>
              );
            }}
          />
        </Grid2>

        <Grid2 size={12}>
          <Controller
            name="allowLowRiskProfile"
            control={form.control}
            render={({ field }) => {
              return (
                <FormControl>
                  <FormLabel
                    style={{
                      color: "#333",
                    }}
                  >
                    Allow clients with lower risk profile to subscribe to the
                    basket?
                  </FormLabel>
                  <RadioGroup {...field}>
                    <FormControlLabel
                      value="true"
                      control={<GKRadio disableLeftPadding />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="false"
                      control={<GKRadio disableTopPadding disableLeftPadding />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              );
            }}
          />{" "}
        </Grid2>
        <Grid2 size={12}>
          <Controller
            name="showPerformance"
            control={form.control}
            render={({ field }) => {
              return (
                <FormControl>
                  <FormLabel
                    style={{
                      color: "#333",
                    }}
                  >
                    Show performance tab:
                  </FormLabel>
                  <RadioGroup {...field}>
                    <FormControlLabel
                      value="true"
                      control={<GKRadio disableLeftPadding />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="false"
                      control={<GKRadio disableTopPadding disableLeftPadding />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              );
            }}
          />{" "}
        </Grid2>
      </Grid2>
      <Show.When isTrue={showPartnerModal}>
        <AddBasketPartner
          setOpen={setShowPartnerModal}
          open={showPartnerModal}
        />
      </Show.When>
    </>
  );
};

export default SettingsTab;
